export const initialValues = {
  applicantInformation: {
    fullName: "",
    contactEmail: "",
  },
  step1: {
    section1: {
      bondBill: "",
      legislativeDistrict: "",
      chapterNumber: undefined,
      authorizedYear: "",
      dgsItemNumber: undefined,
      projectTitle: "",
      streetAddress: "",
      city: "",
      state: "Maryland",
      zipCode: "",
    },
    section2: {
      grantAmount: undefined,
      matchAmount: undefined,
      granteeOrganization: "",
      streetAddress: "",
      state: "",
      zipCode: "",
      city: "",
    },
    section3: {
      isSoloOwner: false,
      isCoOwner: false,
      coOwnerName: "",
      hasLongTermLease: false,
      leaseTerm: undefined,
      doesNotOwn: false,
      ownerName: "",
      ownerEmail: "",
      ownerPhoneNumber: "",
    },
    section4: {
      design: {
        startDate: "",
        finishDate: "",
      },
      construction: {
        startDate: "",
        finishDate: "",
      },
      description: "",
      requirePreservationEasement: "",
      utilizeMBEEnterprise: "",
    },
  },
  step2: {
    estimatedProjectBudget: [],
    q1: "",
    q2: "",
  },
  step3: {},
  step4: {},
  step5: {
    granteeName: "",
    authorizedRepresentative: "",
  },
};
